import PersonAvatar from '@/components/common/PersonAvatar';
import type { DirectoryProvider } from '@/components/services/model/providerDirectory';

interface ProviderAvatarProps {
	provider: Pick<DirectoryProvider, 'name' | 'email'>;
	size?: string;
	fontSize?: string;
}

/**
 * A provider's mark: their initials, whether the documents read them as a person or a company.
 *
 * TODO: Revisit an access marker here with room for a label. A key-only avatar badge gets lost on
 * the denser contact cards, whether it uses the white relationship treatment or an inverted fill.
 */
const ProviderAvatar = (props: ProviderAvatarProps) => {
	const { provider, size = '40px', fontSize = 'sm' } = props;
	return <PersonAvatar name={provider.name} email={provider.email ?? undefined} size={size} fontSize={fontSize} />;
};

export default ProviderAvatar;
